/* eslint-disable no-shadow */

export enum ClaimStatus {
  Idle = 'IDLE',
  Loading = 'LOADING',
  Invalid = 'INVALID',
  NetworkError = 'NETWORK_ERROR',
}

export enum OutreachStatus {
  Pending = 'pending',
  Accepted = 'accepted',
  Rejected = 'rejected',
}

export interface ShiftClaimUrlParams {
  wuserId: string;
}

// Shape matches GET /api/outreach response items
export interface OutreachShift {
  id: string;
  wiw_user_id: string;
  delivery_window_id: string;
  status: OutreachStatus | string;
  created_at: string;
  store_name: string;
  shopper_shift_start: string;
  shopper_shift_end: string;
  driver_shift_start: string;
  driver_shift_end: string;
}

export interface ShiftClaimContextState {
  shifts: OutreachShift[];
  claimedIds: string[];
  rejectedIds: string[];
  claimingId: string | null;
  rejectingId: string | null;
  fetchStatus: ClaimStatus;
}
